module.exports = __webpack_public_path__ + "img/8_43.dc563ef7.png";